import React, { useState, useRef } from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
// import EventBusySharpIcon from '@material-ui/icons/EventBusySharp';
import ScheduleSharpIcon from '@material-ui/icons/ScheduleSharp';
import ShareSharpIcon from '@material-ui/icons/ShareSharp';
import IconButton from '@material-ui/core/IconButton';
import {
  newDateFormat,
  localDateTime,
} from './../../utils/helperFunctions/dateConversions';
import CustomPopover from '../customPopover';

import { InlineShareButtons } from 'sharethis-reactjs';
import AddToCalendar from '@culturehq/add-to-calendar';
import '../../styles/addToCalendarStyles.css';
import { addMinutes, addHours } from 'date-fns';

// import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

import './tooltipStyle.css';

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';


function EventHead({
  homeBackgroundImgContainer,
  imgTitleContainer,
  Image,
  imageStyle,
  titleContainer,
  titleNstatus,
  titleStyle,
  eventName,
  statusCont,
  activIcon,
  activeClass,
  dateTimeCont,
  dateStyle,
  eventDate,
  eventTime,
  eventStatus,
  expiredIcon,
  shareURL,
  homeBackgroundImg,
  homeBackgroundImgCls,
  shareIconCls,
  eventDescription,
  location,
}) {
  const elemRef = useRef(null);
  const [toolTipText, setToolTipText] = useState('Copy to clipboard');
  const toolTipTextShare = 'Share';
  const [anchorEl, setAnchorEl] = useState(false);

  const { eventDateR, eventTimeR } = newDateFormat(eventDate, eventTime);

  const dateTimeCalendar = (date, time, addExtraHr) => {
    const isoDate = new Date(date);
    const [h, m] = localDateTime(eventDate, eventTime).localTime?.split(':');
    // typeof h, typeof (+h + addExtraHr)
    const addHoursDate = addHours(isoDate, +h + addExtraHr);
    const addMinutesDate = addMinutes(addHoursDate, m);
    const dateTimeString = addMinutesDate.toISOString();
    return dateTimeString;
  };

  //   eventDate,
  //   'date ev',
  //   eventTime,
  //   'time ev',
  //   eventDateR,
  //   'date r',
  //   eventTimeR,
  //   'dates'

  const event = {
    name: eventName,
    details: eventDescription,
    location: location,
    startsAt: eventTime ? dateTimeCalendar(eventDateR, eventTime, 0) : null,
    endsAt: eventTime ? dateTimeCalendar(eventDateR, eventTime, 1) : null,
  };

  // '2022-12-06T18:00:00-05:00'

  const handleClick = (event) => {
    setAnchorEl(true);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

    const onClickShareIcon = () => {
    navigator.clipboard.writeText(shareURL);
    setToolTipText('Copied');
  };

  const renderAddToCalendar = () => {
    return eventDate && <AddToCalendar event={event}>{''}</AddToCalendar>;
  };

  const renderEventStatus = (eventStatus) => {
    switch (eventStatus) {
      case 'active':
        return (
          <>
            <CheckCircleSharpIcon className={activIcon} />
            <Typography className={activeClass} variant='caption'>
              Active
            </Typography>
          </>
        );

      case 'expired':
        return (
          <>
            {/* <EventBusySharpIcon className={expiredIcon} /> */}
            <ScheduleSharpIcon className={expiredIcon} />
            <Typography className={activeClass} variant='caption'>
              Not Active
            </Typography>
          </>
        );

      default:
        return (
          <>
            <ScheduleSharpIcon className={expiredIcon} />
            <Typography className={activeClass} variant='caption'>
              Not started
            </Typography>
          </>
        );
    }
  };

  const libShareIcons = (
    <InlineShareButtons
      config={{
        alignment: 'center', // alignment of buttons (left, center, right)
        color: 'social', // set the color of buttons (social, white)
        enabled: true, // show/hide buttons (true, false)
        font_size: 12, // font size for the buttons //16
        labels: 'cta', // button labels (cta, counts, null)
        language: 'en', // which language to use (see LANGUAGES)
        networks: [
          // which networks to include (see SHARING NETWORKS)
          'twitter',
          'facebook',
          'whatsapp',
          // 'linkedin',
          // 'messenger',
        ],
        padding: 3, // padding within buttons (INTEGER) //12
        radius: 4, // the corner radius on each button (INTEGER)
        // show_total: true,
        size: 25, // the size of each button (INTEGER) //40

        // OPTIONAL PARAMETERS
        url: shareURL, // (defaults to current url)
        image: 'https://bit.ly/2CMhCMC', // (defaults to og:image or twitter:image)
        description: '2Gathers', // (defaults to og:description or twitter:description)
        title: eventName, // (defaults to og:title or twitter:title)
        message: eventDescription, // (only for email sharing)
        subject: `${eventName} Share`, // (only for email sharing)
        // username: 'custom twitter handle', // (only for twitter sharing)
      }}
    />
  );

  return (
    <div className={homeBackgroundImgContainer}>
      {homeBackgroundImg ? (
        <CardMedia
          component='img'
          alt='background'
          image={homeBackgroundImg}
          title='background'
          className={homeBackgroundImgCls}
        />
      ) : null}

      <div className={imgTitleContainer}>
        <CardMedia
          component='img'
          alt='event_icon'
          image={Image}
          title='event_icon'
          className={imageStyle}
        />
        <div className={titleContainer}>
          <div className={titleNstatus}>
            <Typography variant='h6' className={titleStyle}>
              {eventName}
            </Typography>
            <div className={statusCont}>{renderEventStatus(eventStatus)}</div>
          </div>
          <div className={dateTimeCont}>
            <Typography variant='caption' className={dateStyle}>
              {eventDateR}
            </Typography>
            <Typography variant='caption' className={dateStyle}>
              {eventTimeR}
            </Typography>
            <div style={{ flex: 1, textAlign: 'end' }}>
              {shareURL ? (
                <>
                <IconButton
                    ref={elemRef}
                    onClick={onClickShareIcon}
                    style={{ padding: 0, marginRight: '5px' }}
                    className={'tooltip-container-event-head'}
                  >
                    <FileCopyOutlinedIcon className={shareIconCls} />
                    <span className={'tooltip-text-event-head'}>
                      {toolTipText}
                    </span>
                  </IconButton>
                  <CustomPopover
                    open={anchorEl}
                    handleClose={handleClose}
                    elRefRen={elemRef}
                  ></CustomPopover>
                  <IconButton
                    ref={elemRef}
                    // onClick={onClickShareIcon}
                    onClick={handleClick}
                    style={{ padding: 0 }}
                    className={'tooltip-container-event-head'}
                  >
                    <ShareSharpIcon className={shareIconCls} />
                    <span className={'tooltip-text-event-head'}>
                      {toolTipTextShare}
                    </span>
                  </IconButton>
                  <CustomPopover
                    open={anchorEl}
                    handleClose={handleClose}
                    elRefRen={elemRef}
                  >
                    <div style={{ padding: 5, width: 'auto' }}>
                      {libShareIcons}
                      <IconButton size='sm'>
                      </IconButton>
                    </div>
                  </CustomPopover>
                </>
              ) : (
                renderAddToCalendar()
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventHead;
